// Global

// Modules
import shop from "./shop";
import global from "./sections/global";
import search from "./templates/search";
import header from "./sections/header";
import footer from "./sections/footer";
// import sidecart from "./sections/sidecart";
// import slidecart from "./sections/slidecart";
import home from "./sections/home";
import pdp from "./sections/pdp";
import pdp_buy_box from "./sections/pdp-buy-box";
import page_our_story from "./sections/page-our-story";
import page_rewards from "./sections/page-rewards";
import page_wcdlp from "./sections/page-wcdlp";
import account_login from './templates/account-login';
import hangover_subscription from './sections/hangover-subscription';
import mega_menu from './sections/mega-menu';
import hblp_buybox from './sections/hblp-buybox';
import './components/variant-radios';
import './sections/lsg-counter';
import './sections/lsg-faq';
import RobloxProducts from './components/roblox-products';
import sfs_5050 from "./sections/sfs-5050";
import sfs_fixed from "./sections/sfs-fixed";
import benefitsAnimation from "./sections/lsg-benefits";
import communitySlider from "./sections/lsg-community";
import ourValuesSlider from "./sections/lsg-our-values";
import stickyCta from "./sections/lsg-sticky-cta";
import testimonialsSlider from "./sections/lsg-testimonials";
import sfs_progress from "./sections/sfs-progress";
import sfs_stats from "./sections/sfs-stats";
import lsg_slidecart from "./sections/lsg-slidecart";
import MultimediaBlock from "./sections/multimedia-blog";
import MultimediaSearch from "./sections/multimedia-search";
import './components/variant-select';
// import './components/product-subscription-form';
import './components/product-form';
import "./components/lsg-upsell-products";
import "./components/lsg-accordion";
import collectionFilter from "./sections/collection-filter";
import DetailsModal from  "./components/details-modal";
import PredictiveSearch from  "./components/predictive-search";
$(function () {
    shop.init();
    global.init();
    search.init();
    header.init();
    mega_menu.init();
    footer.init();
    // sidecart.init();
    // slidecart.init();
    home.init();

    lsg_slidecart.init();

    if ($('body.suffix-seedlings')[0]) {
        sfs_5050.init();
        sfs_fixed.init();
        sfs_progress.init();
        sfs_stats.init();
    }

    if ($('body.suffix-black-history-month')[0]) {
        sfs_fixed.init();
    }

    if ($('body.template-index')[0]) {
        sfs_fixed.init();
    }

    if ($('body.suffix-careers-lp')[0]) {
        benefitsAnimation.init();
        communitySlider.init();
        ourValuesSlider.init();
        stickyCta.init();
        testimonialsSlider.init();
    }

    if ($('body.suffix-hangover-bundle')[0]) {
        hblp_buybox.init();
    }

    if ($('body.template-customers-login')[0]) {
        account_login.init();
    }

    // Hanldes the Convert A/B Subscription Quiz
    if ($('body.suffix-hangover-subscription.convert-hangover-subscription-quiz')[0]) {
        hangover_subscription.init();
    }


    if ($('body.template-product')[0] || $('body.suffix-subscribe')[0]) {
        pdp.init();
        pdp_buy_box.init();
    }

    if ($('body.suffix-our-story')[0]) {
        page_our_story.init();
    }

    if ($('body.suffix-rewards')[0]) {
        page_rewards.init();
    }

    if ($('body.suffix-world-coconut-day-lp')[0]) {
        page_wcdlp.init();
    }

    customElements.define('roblox-products', RobloxProducts);


    document.querySelectorAll('.js-back-btn').forEach(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            if (document.referrer != "") {
                window.location = document.referrer;
            } else {
                window.location = '/';
            }
        });
    });



    const carouselReviewsItems = document.querySelectorAll('.reviews__item-holder');
    carouselReviewsItems.forEach((el) => {
        // translate(${el.getAttribute('data-xStart')}%, ${el.getAttribute('data-yStart')}%)
        el.style.transform = `rotate(${el.getAttribute('data-rotateStart')}deg)`;
    });

    if (!customElements.get('collection-filter')) {
        customElements.define('collection-filter', collectionFilter);
    }

    customElements.define('details-modal', DetailsModal);
    customElements.define('predictive-search', PredictiveSearch);
});

if (!customElements.get('multimedia-block')) {customElements.define('multimedia-block', MultimediaBlock);}
if (!customElements.get('multimedia-search')) {customElements.define('multimedia-search', MultimediaSearch);}
